// removed by extract-text-webpack-plugin
module.exports = {"teamsLandingWrapper":"teamsLanding__teamsLandingWrapper--3Hh3i","teamsHeader":"teamsLanding__teamsHeader--2eiNA"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/TeamsLanding/teamsLanding.css
// module id = CtyP
// module chunks = 24